var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.gridTemplateColumns),attrs:{"id":"app"}},[_c('Header',{attrs:{"title":"LC Base de conhecimento","hideUserDropdown":!_vm.user}}),_c('Menu'),_c('Content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }